import styled from '@emotion/styled';

import { tokens, Tooltip } from '@hotjar/hotsauce';

import { AsyncIcon } from './AsyncIcon';

const Wrapper = styled.span<{ size: number }>`
  background-color: ${tokens.color.ui_background};
  border: 1px solid ${tokens.color.ui_border_light};
  border-radius: 100%;

  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;

  align-items: center;
  display: flex;
  justify-content: center;
  overflow: hidden;
`;

const StyledAsyncIcon = styled(AsyncIcon)`
  display: block;
`;

const containerSizeInPixels = {
  m: 16,
  l: 24,
} as const;

const iconSizeInPixels = {
  m: 10.66,
  l: 16,
} as const;

interface LabelProps {
  className?: string;
  iconName: React.ComponentProps<typeof StyledAsyncIcon>['name'];
  name: string;
  size: 'm' | 'l';
}

export function Label({ className, iconName, name, size }: LabelProps): JSX.Element {
  return (
    <Tooltip text={name}>
      <Wrapper className={className} size={containerSizeInPixels[size]}>
        <StyledAsyncIcon name={iconName} size={iconSizeInPixels[size]} />
      </Wrapper>
    </Tooltip>
  );
}
